export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 3